/* eslint-disable no-param-reassign */
import axios, { AxiosInstance } from 'axios';

import environment from 'environments/environment';

let token: string;

export const setToken = (newToken: string) => {
  token = newToken;
};

const getToken = (): string => {
  return token;
};

const createApi = (baseURL: string): AxiosInstance => {
  const instance = axios.create({ baseURL });

  instance.interceptors.request.use(config => {
    config.headers.Authorization = `Bearer ${getToken()}`;

    return config;
  });

  return instance;
};

const api = createApi(environment.api);

export const certificatesApi = createApi(environment.apiCertificates);
export const lossPreventionApi = createApi(environment.apiLossPrevention);
export const trfRemApi = createApi(environment.apiTrfRem);
export const knowledgePortalApi = createApi(environment.apiKnowledgePortal);

export default api;
